import { Minus, TrendingDown, TrendingUp } from 'lucide-react'
import type { ReactNode } from 'react'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

type InspectionKpiCardProps = {
	icon: ReactNode
	colorClass: string
	label: string
	value: number
	previousValue: number
}

export function InspectionKpiCard({
	icon,
	colorClass,
	label,
	value,
	previousValue,
}: InspectionKpiCardProps) {
	const delta = value - previousValue

	return (
		<Card
			className={cn(
				'flex-col items-start gap-1 rounded-md border-transparent p-3 py-3 text-white shadow-none',
				colorClass,
			)}
		>
			<div className="flex items-center gap-1.5">
				<div className="flex size-5 shrink-0 items-center justify-center rounded-md bg-white/20">
					{icon}
				</div>
				<span className="truncate text-xs font-medium leading-tight text-white/90">
					{label}
				</span>
			</div>
			<div className="flex w-full items-baseline gap-1.5">
				<span className="text-3xl font-bold text-white">{value}</span>
				<span className="flex items-center gap-0.5 text-[11px] text-white/80">
					{delta > 0 ? (
						<TrendingUp className="size-3" />
					) : delta < 0 ? (
						<TrendingDown className="size-3" />
					) : (
						<Minus className="size-3" />
					)}
					mês passado: {previousValue}
				</span>
			</div>
		</Card>
	)
}
